var communityPageMap = null;
var officeMapOjb = null;
var communityMap = function (coords) {
  this.location = coords;
  this.initMap = function () {
    // initializes Google maps
    var map, marker;
    map = new google.maps.Map(document.getElementById("directions-map"), {
      scrollwheel: false,
      center: this.location,
      zoom: 14,
      draggable: false,
    });
    marker = new google.maps.Marker({
      position: this.location,
      map: map,
    });
    google.maps.event.trigger(map, "resize");
  };
};

function LoadOfficeMap() {
  if ($("#community-driving-directions--location").length > 0) {
    var latitude = $("#community-driving-directions--location").attr(
      "data-lat"
    );
    var longitude = $("#community-driving-directions--location").attr(
      "data-long"
    );
    latitude = parseFloat(latitude);
    longitude = parseFloat(longitude);
    var coords = { lat: latitude, lng: longitude };
    communityPageMap = new communityMap(coords);
    $.getScript(
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyAEGf8jSVepdOwgOpiWNMzJYFIrfPhNipo&async=2&callback=communityPageMap.initMap"
    );
  }
}

function InitializeCommunityPageEvents() {
  LoadOfficeMap();

  //if ($('.fl-list').length) {

  //    $('body').on('click vclick keyup', '.show-all-fp', function () {
  //        var button = $(this);
  //        button.closest('.fl-list').find('.fp-col:nth-child(1n+6)').slideDown();
  //        button.hide();
  //        button.closest('.fl-list').find('.hide-all-fp').show();
  //    });
  //    $('body').on('click vclick keyup', '.hide-all-fp', function () {
  //        var button = $(this);
  //        button.closest('.fl-list').find('.fp-col:nth-child(1n+6)').slideUp();
  //        button.hide();
  //        button.closest('.fl-list').find('.show-all-fp').show();
  //    });
  //}

  if ($("#tab-container-floorplans").length > 0) {
    $("#tab-container-floorplans").on("change.zf.tabs", function () {
      LoadOfficeMap();
    });
  }
}

//function InitializeSchema() {

//    $("a[href*='http://']").each(function () {

//        console.log("This is a test" +  $(this).attr("href"));
//    });
//}

$(document).ready(function () {
  InitializeCommunityPageEvents();
});

//$(window).load(function () {
//    InitializeSchema();
//});
